import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'
import { useReviewsWizard } from '../ReviewsWizardProvider'
import { EventId } from '../machineTypes'
import { useSelector } from '@xstate/react'
import Styles from './IntervalSelect.module.scss'
import { Key, useCallback } from 'react'
import { NextScheduledReview } from './AvoidConflicts'
import { ConditionalWrapper } from '../../../common/ConditionalWrapper/ConditionalWrapper'
import { Tooltip } from '../../Tooltip/Tooltip'
import { ReviewFrequency, ReviewInterval } from './constants'

const IntervalFrequency = {
  [ReviewInterval.NONE]: ReviewFrequency.DAILY,
  [ReviewInterval.WEEKDAY]: ReviewFrequency.WEEKLY,
  [ReviewInterval.WEEKLY]: ReviewFrequency.WEEKLY,
  [ReviewInterval.MONTHLY]: ReviewFrequency.MONTHLY,
  [ReviewInterval.QUARTERLY]: ReviewFrequency.MONTHLY,
  [ReviewInterval.ANNUALLY]: ReviewFrequency.YEARLY,
}

export const IntervalSelect = () => {
  const { service } = useReviewsWizard()
  const interval = useSelector(service, (state) => state.context.interval)

  const handleChange = (key: Key) => {
    const frequency = IntervalFrequency[key as ReviewInterval]
    const weekdays = frequency === 'WEEKLY' ? ['MO', 'TU', 'WE', 'TH', 'FR'] : []
    service.send(EventId.SET_INTERVAL, { interval: key, frequency, weekdays })
  }

  const displayText = useCallback((selectedItem: any) => {
    if (selectedItem.key === ReviewInterval.NONE) {
      return selectedItem.rendered
    }

    return (
      <span className={Styles.startSelect}>
        Repeats <span className={Styles.label}>{selectedItem.rendered}</span>
      </span>
    )
  }, [])

  return (
    <NextScheduledReview>
      {({ scheduledReview, isLoading }) => {
        return (
          <ConditionalWrapper
            condition={!!scheduledReview}
            wrapper={(children) => (
              <Tooltip label="A reccurring review is already set up for this doc">
                <div>{children}</div>
              </Tooltip>
            )}
          >
            <Select
              isDisabled={!!scheduledReview || isLoading}
              selectedKey={interval}
              defaultSelectedKey={ReviewInterval.NONE}
              onSelectionChange={handleChange}
              aria-label="Make it recurring"
              variant="tertiary"
              size="lg"
              renderSelectValue={displayText}
            >
              <Item key={ReviewInterval.WEEKDAY}>Every Weekday</Item>
              <Item key={ReviewInterval.WEEKLY}>Weekly</Item>
              <Item key={ReviewInterval.MONTHLY}>Monthly</Item>
              <Item key={ReviewInterval.QUARTERLY}>Quarterly</Item>
              <Item key={ReviewInterval.ANNUALLY}>Annually</Item>
              <Item key={ReviewInterval.NONE}>Does not repeat</Item>
            </Select>
          </ConditionalWrapper>
        )
      }}
    </NextScheduledReview>
  )
}
